'use strict';
// Document workspace — READ-ONLY. Minimal for now; extend with form data / observations / approval / access tabs.
module.exports = {
	Identifier: 'DocumentWorkspace', Ordinal: 250,
	Entity: { Name: 'Document', IDField: 'IDDocument', Collection: 'Documents', GUIDField: 'GUIDDocument' },
	Header: { Eyebrow: 'Document', Title: (r) => r.Name || `Document ${r.IDDocument}`, ListRoute: '#/PSRS/Document/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [
		{ Key: 'Name', Label: 'Name', Wide: true }, { Key: 'DocumentType', Label: 'Type' }, { Key: 'Status', Label: 'Status' },
		{ Key: 'DocumentDate', Label: 'Date', Format: 'date' }, { Key: 'IDProject', Label: 'Project', Mono: true } ] } ],
};
